<template>
  <LayoutBaseContent class="max-w-7xl">
    <div class="container-padding flex flex-wrap md:flex-no-wrap justify-between">
      <div class="flex flex-col justify-center">
        <h1 v-if="$breakpoint.smAndUp" class="font-medium text-4xl">Download Our Mobile App</h1>

        <p class="mt-2">
          Use SellMyLivestock on the go with our dedicated iOS and Android mobile apps.
        </p>

        <p class="mt-2">
          With push notifications you'll never miss a message and be able to trade without ever leaving the field.
        </p>

        <div class="flex flex-wrap items-center">
          <a v-if="app.device.operatingSystem !== 'android'" :href="appDownloadUrls.ios">
            <img
              alt="ios download"
              v-lazy="require('@/assets/images/logos/app-store/ios.png')"
              class="h-20 mr-8 mt-8"
            />
          </a>

          <a v-if="app.device.operatingSystem !== 'ios'" :href="appDownloadUrls.android">
            <img
              alt="android download"
              v-lazy="require('@/assets/images/logos/app-store/android.png')"
              class="h-20 mt-8"
            />
          </a>
        </div>
      </div>

      <div class="mt-8 sm:mt-0 sm:pl-8">
        <img alt="app screenshots" v-lazy="require('@/assets/images/backgrounds/apps.jpg')" />
      </div>
    </div>
  </LayoutBaseContent>
</template>

<script>
import { generateMetaTags } from '@/lib/generate-meta'
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'

export default {
  name: 'AppDownload',
  components: {
    LayoutBaseContent
  },
  data() {
    return {
      appDownloadUrls: {
        ios: process.env.VUE_APP_DOWNLOAD_IOS_URL,
        android: process.env.VUE_APP_DOWNLOAD_ANDROID_URL
      }
    }
  },
  head: {
    title() {
      return {
        inner: 'Download Our Mobile Apps'
      }
    },
    meta() {
      return generateMetaTags()
    }
  }
}
</script>

<style lang="scss">
.sitemap-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, 19%);
  grid-gap: 1.5rem 1%;
}

#app.smAndDown {
  .sitemap-columns {
    grid-template-columns: repeat(auto-fit, 30%);
  }
}
</style>
